export enum OrderFields {
    Receiver = 'destinatario',
    Address = 'direccion',
    Items = 'mercaderia',
    StatusCode = 'codEstado',
    StatusDesc = 'descEstado',
    OrderDate = 'fechaAlta',
    DeliveryDate = 'fechaEntrega',
    User = 'idUsuarioAlta',
    DisplayOrder = 'orden',
    Observations = 'observaciones',
    InvoiceNumber = 'factura',
    DeliveryNote = 'remito',
}

export enum OrderFilterFields {
    StatusCodeList = 'estados',
    OrderDateStart = 'fechaAltaDesde',
    OrderDateEnd = 'fechaAltaHasta',
    IsBilled = 'facturado',
    DeliveryDateStart = 'fechaEntregaDesde',
    DeliveryDateEnd = 'fechaEntregaHasta',
}

export enum OrderSummaryFields {
    PendingQuantity = 'cantidadPendientes',
    DelayedQuantity = 'cantidadDemorados',
    DeliveredCurrentMonth = 'entregasMesActual',
    DeliveredPreviousMonth = 'entregasMesAnterior',
    UnbilledQuantity = 'cantidadSinFacturar'
}